module.exports = __webpack_public_path__ + "img/bg_five.33989c5a.jpg";